import { Observable, retry, throwError, timer } from 'rxjs';

export interface BackoffConfig {
  maxAttempts?: number;
  initialDelay?: number;
  statusCodes?: number[];
}

export function retryWithBackoff(config: BackoffConfig = {}) {
  const maxAttempts = config.maxAttempts ?? 3;
  const initialDelay = config.initialDelay ?? 1000; // 1 second
  const statusCodes = config.statusCodes ?? [0, 500, 502, 503, 504];

  return <T>(source: Observable<T>) =>
    source.pipe(
      retry({
        count: maxAttempts,
        delay: (error, retryCount) => {
          if (statusCodes.includes(error.status)) {
            const delayTime = Math.pow(2, retryCount - 1) * initialDelay;
            console.warn(`Attempt ${retryCount} failed. Retrying in ${delayTime}ms...`);
            return timer(delayTime);
          }
          return throwError(() => error);
        },
      })
    );
}
